import apiClient from './client'
import type { Agenda, PaginatedResponse, UpdateAgendaRequest } from '@/types/agenda'

export const miAgendaApi = {
    getAll: (params?: { fecha?: string; fechaDesde?: string; fechaHasta?: string; page?: number; pageSize?: number }) =>
        apiClient.get<PaginatedResponse<Agenda>>('/agenda/mi', { params }).then((r) => r.data),

    update: (id: string, data: UpdateAgendaRequest) =>
        apiClient.patch<Agenda>(`/agenda/${id}`, data).then((r) => r.data),
}
